<div class="routine-compliance-container">
  <app-compliance-tasks
    [taskType]="'routine'"
    [columns]="columns"
    [data]="routineComplianceTasks"
    [expandable]="true"
    [subColumns]="subColumns"
    [subRowsEmptyMessage]="'compliance.overview.routineTasks.noScheduledInspections' | transloco"
    [isLoading]="isLoading"
    [isLoadingMore]="isLoadingMore"
    [isRefreshing]="isRefreshing"
    [hasError]="hasError"
    [minWidth]="1200"
    (rowClicked)="onRowClick($event)"
    (assignWorkshopClicked)="onAssignWorkshop($event)"
    (reschedulePreClicked)="onReschedule($event, 'pre')"
    (reschedulePostClicked)="onReschedule($event, 'post')"
    (deleteClicked)="onDelete($event)"
    (searchChanged)="onSearch($event)"
    (statusFilterChanged)="onStatusFilter($event)"
    (scrolledDown)="onScrollDown()">
  </app-compliance-tasks>
</div>
